module.exports = __webpack_public_path__ + "img/zf_tab_2.aa393ed0.png";